<script lang="ts">
  import { Container, Row } from "sveltestrap";
  import BookmarkUserProfile from "./BookmarkUserProfile.svelte";
  import UserProfileHeader from "./UserProfileHeader.svelte";
  import UserProfileAbout from "./UserProfileAbout.svelte";
  import UserProfilePost from "./UserProfilePost.svelte";
</script>

<BookmarkUserProfile />
<Container fluid>
  <div class="user-profile">
    <Row>
      <UserProfileHeader />
      <UserProfileAbout />
      <UserProfilePost />
    </Row>
  </div>
</Container>
